/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IReadOnlyListOfMyCalendarDto } from './iReadOnlyListOfMyCalendarDto.schema';

export const PagedResultOfMyCalendarDto = zod.object({
  "items": zod.lazy(() => IReadOnlyListOfMyCalendarDto).optional(),
  "pageNumber": zod.number().optional(),
  "pageSize": zod.number().optional(),
  "totalItems": zod.number().optional(),
  "totalPages": zod.number().optional(),
  "hasNextPage": zod.boolean().optional(),
  "hasPreviousPage": zod.boolean().optional()
});

export type PagedResultOfMyCalendarDto = zod.input<typeof PagedResultOfMyCalendarDto>;
export type PagedResultOfMyCalendarDtoOutput = zod.output<typeof PagedResultOfMyCalendarDto>;
